<template>
  <div :class="['picd','picd', 'useType'+UseType]">
    <ul id="attachment" style="padding:0">
        <li style="float:left" v-for="item,index of DocData" :key="index">
            <div class="imgd" :title="item.DName">
                <div class="overd" v-if="ShowDelete">
                    <div class="dwd deld pointer float-l" v-on:click="DelAttachment(item.ID)" :erid="item.ObjectID" title="删除"></div>
                    <div class="clear"></div>
                </div>
                <div @click='OpenPage(FileAddress+item.FilePath,item.ID,item.FileType.toLowerCase())' class="zshowbox">
                    <img src="../assets/img/pdf.png" class="common-img"  v-if='item.FileType.toLowerCase() == "pdf"'/>
                    <img src="../assets/img/docx.png" class="common-img"  v-else-if='item.FileType.toLowerCase() == "doc" || item.FileType.toLowerCase() == "docx"'/>
                    <img src="../assets/img/ppt.png" class="common-img"  v-else-if='item.FileType.toLowerCase() == "ppt" || item.FileType.toLowerCase() == "pptx"'/>
                    <img src="../assets/img/txt.png" class="common-img"  v-else-if='item.FileType.toLowerCase() == "txt"'/>
                    <img src="../assets/img/xls.png" class="common-img"  v-else-if='item.FileType.toLowerCase() == "xls" || item.FileType.toLowerCase() == "xlsx"'/>
                    <img src="../assets/img/rar.png" class="common-img"  v-else-if='item.FileType.toLowerCase() == "zip" || item.FileType.toLowerCase() == "rar"'/>
                    <img :src="FileAddress + item.FilePath" class="common-img"  v-else-if='IsImg(item.FileType.toLowerCase())'/>
                    <video width="108" height="80" controls v-else-if='item.FileType.toLowerCase() == "mp4" || item.FileType.toLowerCase() == "webm" || item.FileType.toLowerCase() == "ogg"'>
                        <source :src="FileAddress +item.FilePath" :type="'video/' + item.FileType">
                        视频不存在或网络有问题
                    </video>
                    <div class="common-else" :title='("."+item.FileType.toLowerCase())' v-else>{{"."+item.FileType.toLowerCase()}}</div>
                </div>
            </div>
        </li>
    </ul>
    <div class="clear"></div>
  </div>
</template>

<script>
// import util from '../commonJs/http'
// import config from '../../public/config'
export default {
  name: "AttachmentList",
  data() {
    return {
        DocData:[],
        FileAddress:""
    };
  },
  props: {
    // 附件所属ID
    objectID: {
      type: String
    },
    // 使用类型 0:普通附件,1:标题图片，2:富文本编辑器中的图片，可自行扩展
    UseType: {
      type: Number,
      default: 0
    },
    TableName:{
      type:String,
      default:''
    },
    ShowDelete:{
      type:Boolean,
      default:true
    },
    DispatchTime:{
      type:String,
      default:''
    },
    IsAllImg:{
      type:Boolean,
      default:false
    },
    IsClick: {
        type: Boolean,
        default: true
    },
  },

  methods: {
    /** 调用接口获取文件 */
    GetAttachmentList() {
      let that = this;
      console.log("GetAttachmentList")
          that.$api.post(process.env.VUE_APP_FileAddress + "Main/getDocumentInfoList?appID=" + process.env.VUE_APP_FileSysID
          + "&fileSystemKey=" + process.env.VUE_APP_FileSysToken+"&typeID=0&objectID="+this.objectID
      +"&useType="+this.UseType+"&tableName="+this.TableName+"&dispatchTime="+that.DispatchTime,{},
        function (res) {
          that.DocData=res.data;
          that.$emit("AttachmentList",that.DocData,that.objectID);
        },
        function () {}
      );
    },
    /** 调用接口删除文件 */
    DelAttachment(id) {
      if (confirm("确定删除附件?")) {
        let that = this;
          that.$api.post(process.env.VUE_APP_FileAddress + "Main/deleteDocumentInfo?appID=" + process.env.VUE_APP_FileSysID
            + "&fileSystemKey=" + process.env.VUE_APP_FileSysToken+"&typeID=0&id="+id,{},
          function (res) {
              that.GetAttachmentList();
          },
          function () {}
        );
      }
      },
    IsImg(fileType){
        return fileType == "bmp" || fileType == "jpg" || fileType == "png" || fileType == "gif" || fileType == "jpeg";
    },
    OpenPage(url,id,fileType){
        if (this.IsClick == false) { return false; }
        let _this = this;
        if (_this.IsAllImg && _this.IsImg(fileType)) {
            const { href } = _this.$router.resolve({
                name: "AttachmentImgList", query: {
                    objectID: _this.objectID,
                    UseType: _this.UseType,
                    TableName: _this.TableName,
                    DispatchTime: _this.DispatchTime,
                    ID: id
                }
            });
            window.open(href, "_blank");
        } else {
            window.open(url, "_blank");
        }
      },
    Clear() {
        this.DocData = [];
    }
  },
  mounted() {
    let that = this;
    that.FileAddress=process.env.VUE_APP_FileAddress.replace('fileapi/','');
    this.$nextTick(() => {
      setTimeout(() => {
        that.GetAttachmentList();
      }, 300);
    });
  }
};
</script>
<style lang="less" scoped>
.common-else{
  width: 80px; height: 80px;text-align: center;padding-top: 30px;
}
.common-img{
  width: 80px;
  height: 80px;
}
/*表单图片上传*/
.picd {
	width: 100%;
	overflow:auto;
	overflow-x: hidden;
  min-height:115px;
  }
.picd ul li {
  float: left;
  height: auto;
  margin: 5px 10px 5px 0;
  /*width: 80px;*/
	border: 1px solid #d3d3d3;
  list-style:none
  }
.picd .imgd  {
	position:relative;
    height: 80px;
	border-bottom:1px solid #d3d3d3;
    cursor:pointer;
}

.picd .img-upd {
	width: 150px;
    height: 149px;
}
.picd .imgd  .overd{
	position: absolute;
	bottom:0;
	width: 100%;
  height: 30px;
	display:none;
  z-index: 9;
	background:url("../assets/img/bj_Transparent1.png") repeat;
}
.picd .imgd:hover .overd {display: block;}

.picd .imgd .dxd{width:148px;height:119px;}
.picd .imgd .overd .dwd{
	width: 16px;
  height: 16px;
	margin:7px 8px 0 8px;}
.picd .imgd .overd .deld  {
	background:url("../assets/img/tb_img_del.png") no-repeat;
  cursor: pointer;
}

.picd .textd
{
    margin:0 auto;
    cursor: pointer;
    height: 29px;
    line-height: 29px;
    overflow: hidden;
    width: 95%;
}

</style>
